import { N11_04 } from "./N11_04";

export const N11_03 = {
  selectedValueColumn: "DrillKey",
  selectedTitle: "Territory",
  visual: [
    {
      columns: 12,
      rows: 2,
      visual: {
        id: 1,
        type: "advancedTable",
        colorTheme: "colorTheme1",
        title: "Territory",
        binding: {
          data: {
            columns: [
              {
                name: "Territory",
                columnName: "TerritoryName",
                width: "450px",
                align: "left",
                sortable: true
              },
              {
                name: "Agent Name",
                columnName: "AgentName",
                width: "300px",
                align: "left",
                sortable: true
              },
              {
                name: "Reached",
                columnName: "ReachedAccounts",
                width: "180px",
                align: "center",
                sortable: true
              },
              {
                name: "Total Accounts",
                columnName: "TotalAccounts",
                width: "180px",
                align: "center",
                sortable: true
              },
              {
                name: "Call Reach",
                columnName: "CallReach",
                width: "180px",
                align: "center",
                sortable: true,
                percent: true
              },
            ],
            title: "TerritoryName",
            endpoint: "SFE_N11.3",
            parameters: [
              { key: "CycleCode", value: "CP1" },
              { key: "CycleYear", value: "2026" },
              { key: "DrillKey", value: "" },
            ],
          },
          context: {
            point: {
              onClick: N11_04,
            },
          },
        },
      },
    },
  ],
};